import { Component } from '@angular/core';
import { MdDialogRef } from '@angular/material';
export class TdPromptDialogComponent {
  title: string;
  message: string;
  value: string;
  cancelButton: string = 'CANCEL';
  acceptButton: string = 'ACCEPT';
/**
 * @param {?} _dialogRef
 */
constructor(private _dialogRef: MdDialogRef<TdPromptDialogComponent>) {}
/**
 * @return {?}
 */
cancel(): void {
    this._dialogRef.close(undefined);
  }
/**
 * @return {?}
 */
accept(): void {
    this._dialogRef.close(this.value);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'td-prompt-dialog',
  templateUrl: './prompt-dialog.component.html',
  styleUrls: ['./prompt-dialog.component.css' ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdDialogRef, },
];
}

function TdPromptDialogComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdPromptDialogComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdPromptDialogComponent.ctorParameters;
/** @type {?} */
TdPromptDialogComponent.prototype.title;
/** @type {?} */
TdPromptDialogComponent.prototype.message;
/** @type {?} */
TdPromptDialogComponent.prototype.value;
/** @type {?} */
TdPromptDialogComponent.prototype.cancelButton;
/** @type {?} */
TdPromptDialogComponent.prototype.acceptButton;
/** @type {?} */
TdPromptDialogComponent.prototype._dialogRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
